import React, { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row,OverlayTrigger,Tooltip } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";

// imgss
import u1 from "../../../Assets/images/authBg.png";
import { Link } from "react-router-dom";
import { CstmPagination } from "../../../components/Common/Common";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import {
  useDeleteMealMutation,
  useGetMealsQuery,
  useUpdateMealMutation,
} from "../../../store/services/mealService";
import { useAddRefundMutation } from "../../../store/services/refundService";
import { useGetRefundQuery, useGetRefundExportFileMutation } from "../../../store/services/refundService";
import MealsPop from "../../../components/Modals/MealsPop";
import RefundPop from "../../../components/Modals/RefundApprovedPop";
import RefundRejectPop from "../../../components/Modals/RefundRejectPop";
import CoolerBag from "../../../components/Modals/CoolerBagPop";
import toast from "react-hot-toast";
import moment from "moment";

const RefundTransaction = () => {
  const [confirmation, setConfirmation] = useState();
  const [bodyData, setBodyData] = useState({
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    pageNo: 1,
    status: "",
    search: "",
    type: "",
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpens, setModalOpens] = useState(false);
  const [modalOpenRej, setModalOpenRej] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [edit, setEdit] = useState(null);
  const [Loading, setLoading] = useState(false);
  const handleConfirmation = () => setConfirmation(!confirmation);
  const { data: meals, error, isLoading } = useGetRefundQuery(bodyData);
  const [exportUsers, { isLoading: isExporting }] =
    useGetRefundExportFileMutation();

  const [deleteMeal, { isLoading: isDeleting }] = useDeleteMealMutation();
  const [updateMeal, { isLoading: isUpdating }] = useUpdateMealMutation();
  const [rejectRefund,] = useAddRefundMutation();

  const handleStatusChange = async (id, status) => {
    try {
      await updateMeal({
        mealId: id,
        updatedData: { status: status },
      });
      //return toast.success(`Meal updated successfully`);
      if (status === "active") {
        toast.success(`Meal successfully activated`);
      } else {
        toast.success(`Meal successfully deactivated`);
      }
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle errorr
    }
  };
  // const toastHandler = () => {
  //   toast.error("sdjfhkljdsnfkjsndlk")
  // }
  useEffect(() => {
    if (modalOpen === false && edit !== null) {
      setEdit(null);
    }
  }, [modalOpen]);

  if (error) {
    return <p>Something went wrong: {error.message}</p>;
  }

  console.log("meals =======>", meals);

  const column = [
    // {
    //   head: "Sr. No.",
    //   accessor: "#",
    //   component: (item, key) => {
    //     const startingIndex = (bodyData.pageNo - 1) * bodyData.limit; // Calculate starting index based on pageNo and limit
    //     const serialNumber = startingIndex + key + 1; // Calculate serial number based on key and starting index

    //     return <>{serialNumber < 10 ? `0${serialNumber}` : serialNumber}</>;
    //   },
    // },
    {
      head: "Name",
      accessor: "name",
      component: (item, key, arr) => (
        <p className="m-0 themeBlue fw-sbold">{item?.userDetails?.name}</p>
      ),
    },
    // {
    //   head: "Email",
    //   accessor: "email",
    //   component: (item, key, arr) => (
    //     <p className="m-0 themeBlue fw-sbold overflow-hidden text-truncate">{item?.userDetails?.email}</p>
    //   ),
    // },
    {
      head: "Email",
      accessor: "email",
      component: (item, key, arr) => (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>{item?.userDetails?.email}</Tooltip>}
        >
          <p className="m-0 themeBlue fw-sbold overflow-hidden text-truncate">
            {item?.userDetails?.email}
          </p>
        </OverlayTrigger>
      ),
    },
    // {
    //   head: "Amount",
    //   accessor: "amount",
    //   component: (item, key, arr) => (
    //     <p className="m-0 themeBlue fw-sbold">{item.refundableAmount}</p>
    //   ),
    // },
    //

    {
      head: "Amount",
      accessor: "amount",
      component: (item, key, arr) => {
        const redTypes = ["coolerBag", "swapRefund", "orderCancel"];
        const greenTypes = ["swapPayment", "orderPayment", "coolerBagCharge"];

        if (!item.refundableAmount && item.refundableAmount !== 0) {
          return <p className="m-0 themeBlue fw-sbold">-</p>; // Show "-" if amount is missing
        }

        let formattedAmount = `${item.refundableAmount} AED`;
        let textColor = "themeBlue"; // Default color

        if (redTypes.includes(item.type)) {
          formattedAmount = `- ${Math.abs(item.refundableAmount)} AED`; // Always show "-" for these types
          textColor = "text-danger"; // Red color
        } else if (greenTypes.includes(item.type)) {
          formattedAmount = `+ ${Math.abs(item.refundableAmount)} AED`; // Always show "+" for these types
          textColor = "text-success"; // Green color
        }

        return (
          <p className={`m-0 ${textColor} fw-sbold`}>{formattedAmount}</p>
        );
      },
    },

    {
      head: "Order ID",
      accessor: "orderID",
      component: (item, key, arr) => (
        <p className="m-0 themeBlue fw-sbold">{item?.orderDetails?.orderID}</p>
      ),
    },
    {
      head: "Status",
      accessor: "status",
      component: (item, key, arr) => (
        <p className="m-0 themeBlue fw-sbold text-capitalize">{item?.status}</p>
      ),
    },
    {
      head: "Type",
      accessor: "type",
      component: (item, key, arr) => (
        <p className="m-0 themeBlue fw-sbold text-capitalize">{item?.type}</p>
      ),
    },
    {
      head: "Created At",
      accessor: "createdAt",
      component: (item, key, arr) => (
        <>{moment(item?.createdAt).format("DD/MM/YYYY")}</>
      ),
    },

    {
      head: "Actions",
      accessor: "Action",
      component: (item, key, arr) => {
        const isHidden = ["success", "approved", "cancelled", "rejected"].includes(item.status.toLowerCase());
        const isDisabled = ["cancelled", "rejected"].includes(item.status.toLowerCase());

        return (
          <div className="actionBtn d-flex align-items-center gap-10">
            {/* View Detail Links */}
            <Link
              to={`/refund-transaction/detail/${item?._id}`}
              className="border-0 p-0"
              variant="transparent"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="13"
                viewBox="0 0 21 13"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.1269 0.379883C6.00023 0.379883 2.81476 3.30125 1.26883 5.0114C0.614598 5.73509 0.23969 6.2714 0.23969 6.2714C0.0900251 6.48573 0.0900251 6.77233 0.23969 6.98666C0.23969 6.98666 0.534721 7.40936 1.05152 8.0024C2.50253 9.6674 5.79632 12.8782 10.1269 12.8782C14.572 12.8782 17.9291 9.49839 19.3181 7.87307C19.7642 7.35098 20.0152 6.98666 20.0152 6.98666C20.1649 6.77233 20.1649 6.48573 20.0152 6.2714C20.0152 6.2714 19.7398 5.87467 19.2535 5.31173C17.8276 3.6621 14.5055 0.379883 10.1269 0.379883ZM10.1269 1.62996C13.8634 1.62996 16.9827 4.59581 18.3074 6.12852C18.5725 6.43529 18.5974 6.48424 18.7089 6.63143C18.605 6.76803 18.593 6.79697 18.3671 7.06124C17.0781 8.56964 13.9201 11.6281 10.1269 11.6281C6.43137 11.6281 3.34181 8.72873 1.99268 7.18081C1.70294 6.8484 1.67185 6.78672 1.55443 6.63143C1.69037 6.45001 1.77636 6.31473 2.19543 5.85135C3.63536 4.25828 6.60534 1.62996 10.1269 1.62996ZM10.1269 2.88004C8.06297 2.88004 6.38027 4.56274 6.38027 6.62663C6.38027 8.69036 8.06297 10.378 10.1269 10.378C12.1906 10.378 13.8783 8.69036 13.8783 6.62663C13.8783 4.56274 12.1906 2.88004 10.1269 2.88004ZM10.1269 4.13127C11.5152 4.13127 12.6282 5.23814 12.6282 6.62663C12.6282 8.01496 11.5152 9.12794 10.1269 9.12794C8.73837 9.12794 7.6315 8.01496 7.6315 6.62663C7.6315 5.23814 8.73837 4.13127 10.1269 4.13127Z"
                  fill="#645C5C"
                />
              </svg>
            </Link>

            {/* Approve Button - Hidden for success/approved, Disable for cancel/rejected */}
            {!isHidden && (
              <Button
                type="button"
                // className="border-0 p-0"
                className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn"
                style={{ height: 40, minWidth: 70, fontSize: 12 }}
                variant="transparent"
                onClick={() => {
                  setModalOpen(true);
                  setEdit(item);
                }}
                title="approve"
                disabled={isDisabled}
              >
                Approve
              </Button>
            )}

            {/* Reject Button - Hidden for success/approved, Disabled for cancelled/rejected */}
            {!isHidden && (
              <Button
                type="button"
                //className="border-0 p-0"
                className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn"
                style={{ height: 40, minWidth: 80, fontSize: 12 }}
                variant="transparent"
                onClick={() => {
                  setModalOpenRej(true);
                  setEdit(item);
                }}
                title="reject"
                disabled={isDisabled}
              >
                Reject
              </Button>
            )}
          </div>
        );
      },
    }
  ];

  const confirmHandler = async () => {
    try {
      await deleteMeal(deleteId).unwrap(); // Call deleteMeal and handle successs
      setConfirmation(false);
      return toast.success("Meal deleted successfully");
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle errors
    }
  };
  const handlePageChange = (selectedPage) => {
    setBodyData((prevState) => ({
      ...prevState,
      pageNo: selectedPage.selected + 1, // Update the page number (selected is 0-based index)
    }));
  };

  const options = [
    { value: "coolerBag", label: "Cooler Bag Refund" },
    { value: "orderCancel", label: "Order Cancel" },
    { value: "orderPayment", label: "Order Payment" },
    { value: "swapRefund", label: "Swap Refund" },
    { value: "swapPayment", label: "Swap Payment" },
    { value: "coolerBagCharge" , label: "Cooler Bag Charge"},
  ];

  const optionsStatus = [
    { value: "approved", label: "Approved" },
    { value: "cancelled", label: "Cancelled" },
    { value: "pending", label: "Pending" },
    { value: "rejected", label: "Rejected" },
    { value: "success", label: "Success" },
  ];

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setBodyData((prev) => ({ ...prev, type: selectedValue }));
  };

  const handleChangeStatus = (event) => {
    const selectedValue = event.target.value;
    setBodyData((prev) => ({ ...prev, status: selectedValue }));
  };

  const exportHandler = async () => {
    setLoading(true);
    try {
      const data = await exportUsers().unwrap();
      if (data.status_code === 200) {
        const downloadUrl = data.data; // Assuming data.data contains the file URLs

        // Create an invisible link elements
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", ""); // Use this to prompt download
        link.style.display = "none";

        // Append the link to the body, click it to initiate the download, then remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle errorr
    } finally {
      setLoading(false); // Stop loading
    }
  };


  return (
    <>
      <ConfirmationPop
        confirmation={confirmation}
        setConfirmation={setConfirmation}
        confirmHandler={confirmHandler}
        type="confirmation"
      />
      {modalOpen && (
        <RefundPop
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          title={`${edit ? "Approved" : "Add"} Refund`}
          edit={edit}
        />
      )}

      {modalOpens && (
        <CoolerBag
          modalOpen={modalOpens}
          setModalOpen={setModalOpens}
          title={`${edit ? "Cooler Bag" : "Cooler Bag"} Refund`}
          edit={edit}
        />
      )}

      <RefundRejectPop
        modalOpenRej={modalOpenRej}
        setModalOpenRej={setModalOpenRej}
        //title={`${edit ? "Approved" : "Add"} Refund`}
        title="Are you sure you want to reject?"
        edit={edit}
      />


      <section className="manageusers py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Refund Transactions
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    
                    <li className="">
                      <div className="searchBox position-relative iconWithText">
                        <Button
                          className="border-0 p-0 position-absolute icn"
                          variant="transparent"
                          style={{ right: 10 }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                          >
                            <path
                              d="M18.2462 17.225L13.1462 12.125C14.1212 10.925 14.7212 9.35 14.7212 7.625C14.7212 3.725 11.4962 0.5 7.59619 0.5C3.69619 0.5 0.471191 3.725 0.471191 7.625C0.471191 11.525 3.69619 14.75 7.59619 14.75C9.32119 14.75 10.8212 14.15 12.0962 13.175L17.1962 18.275C17.3462 18.425 17.5712 18.5 17.7212 18.5C17.8712 18.5 18.0962 18.425 18.2462 18.275C18.5462 17.975 18.5462 17.525 18.2462 17.225ZM7.59619 13.25C4.52119 13.25 1.97119 10.7 1.97119 7.625C1.97119 4.55 4.52119 2 7.59619 2C10.6712 2 13.2212 4.55 13.2212 7.625C13.2212 10.7 10.6712 13.25 7.59619 13.25Z"
                              fill="#C4C4C4"
                            />
                          </svg>
                        </Button>
                        <input
                          type="text"
                          placeholder="Search Order ID"
                          className="form-control"
                          onChange={(e) =>
                            setBodyData((prevState) => ({
                              ...prevState,
                              search: (e.target.value.trimStart()),
                              pageNo: 1
                            }))
                          }
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    {/* <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        Import CSV
                      </Button>
                    </li>
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        Export CSV
                      </Button>
                    </li> */}



                    <li>
                      <select
                        id="status"
                        className="rounded-lg border border-gray-300 p-2 focus:outline-none focus:ring focus:ring-blue-500"
                        onChange={handleChangeStatus}
                        defaultValue=""
                      >
                        <option value="" >
                          Select status
                        </option>
                        {optionsStatus.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </li>

                    <li>
                      <select
                        id="status"
                        className="rounded-lg border border-gray-300 p-2 focus:outline-none focus:ring focus:ring-blue-500"
                        onChange={handleChange}
                        defaultValue=""
                      >
                        <option value="" >
                          Select type
                        </option>
                        {options.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </li>

                    {/* <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        disabled={isExporting}
                        onClick={exportHandler}
                      >
                        Export CSV
                      </Button>
                    </li> */}

                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        disabled={Loading} // Disable button while load
                        onClick={exportHandler}
                      >
                        {Loading ? 'Exporting...' : 'Export CSV'}
                      </Button>
                    </li>


                    <li className="">
                      <button
                        type="button"
                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        onClick={() => {
                          setModalOpens(true);
                        }}
                      >
                        Cooler Bag Refund/Charge
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              {isLoading && (
                <div className="text-center">
                  <div className="spinner-border text-dark" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
              {!isLoading && meals?.data?.length > 0 && (
                <TableLayout column={column} data={meals?.data} />
              )}
              {!isLoading && meals?.data?.length === 0 && (
                <div className="text-center">No data Found</div>
              )}
              {meals?.data?.length > 0 && (
                <CstmPagination
                  pageCount={meals?.totalcount / bodyData.limit}
                  onPageChange={handlePageChange}
                  itemsPerPage={bodyData.limit}
                  totalItems={meals?.totalcount}
                  currentPage={bodyData?.pageNo}
                />
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default RefundTransaction;
